import { createSlice } from "@reduxjs/toolkit";

const initialState = { 
  selectedTab : "today",
};

const appointmentReducer = createSlice({
  name: "appointmentReducer",
  initialState,
  reducers: {
    setSelectedTab(state,action){
      state.selectedTab = action.payload;
    },
  },
});
export const { setSelectedTab } = appointmentReducer.actions;
export default appointmentReducer.reducer;
